export default __webpack_public_path__ + "static/media/resume2022.df4afa5e.pdf";